import axiosInstance from "./AxiosInstance";

export function getDeletedHistory(data) {
  return axiosInstance.post("/admin/candidate/all/delete-logs", data);
}

export function changeStatus(data) {
  return axiosInstance.post("/admin/candidate/update-job-fair-status", data);
}

export function getActionHistory(data) {
  return axiosInstance.post("/admin/candidate/users/activities", data);
}
